import { render, staticRenderFns } from "./BorderSetting.vue?vue&type=template&id=193b5432&scoped=true"
import script from "./BorderSetting.vue?vue&type=script&lang=js"
export * from "./BorderSetting.vue?vue&type=script&lang=js"
import style0 from "./BorderSetting.vue?vue&type=style&index=0&id=193b5432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193b5432",
  null
  
)

export default component.exports